import { ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges } from '@angular/core';
import { ApiServiceModule } from '../../modules/api-service.module';
import { SharedService } from '../../modules/shared-service.service';
import config from 'config/default.json';

@Component({
  selector: 'app-vcl-promotion',
  templateUrl: './vcl-promotion.component.html',
  styleUrls: ['./vcl-promotion.component.scss']
})
export class VclPromotionComponent {
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    private sharedService: SharedService) {
  }
  @Input() userInfos: { [x:string]: any } = new Map();
  pageId = 'vcl-promotion'
  dataSource:{[x: string]: any}[] = [];
  products:{[x: string]: any}[] = [];
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}
  

  ngOnInit(): void {
    if(Object.keys(this.userInfos).length) this.loadPromotionData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userInfos'] && !changes['userInfos'].firstChange) {
      this.loadPromotionData();
    }
  }
  loadPromotionData(){
    this.sharedService.sendData({in_progress: true});
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/promotion/load_all_promotion', {id_user: this.userInfos['id_user'], platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response: any)=>{
      this.dataSource = response['promotion'];
      this.products = response['product'];
      this.sharedService.sendData({in_progress: false});
    });
  }
}
